<div class="pb-1">
  <div class="row d-flex justify-content-center">
    <div
      class="header-icon"
      [class.gray]="color === 'gray'"
      [ngStyle]="{
        display: backgroundImageUrl?.length > 0 ? 'block' : 'none',
        'background-image':
          backgroundImageUrl?.length > 0 ? 'url(' + backgroundImageUrl + ')' : null
      }"
    ></div>
  </div>
  <div *ngIf="title" class="row w-100 mx-0 mt-2 header-icon-text title">
    <span class="text-size-14 px-2 text-center w-100" [class.gray]="color === 'gray'" [class.big]="bigTitle">
      {{ title }}
    </span>
  </div>
  <div class="row w-100 mx-0 mt-2 header-icon-text description">
    <span class="text-size-14 px-2 text-center w-100" [class.gray]="color === 'gray'">
      {{ description }}
    </span>
  </div>
</div>
